export default function LoadingText({
  as: Component = 'span',
  children,
  className = '',
  style = {},
  ...props
}) {
  const resolvedClassName = ['ui-loading-text', className].filter(Boolean).join(' ');
  const shimmerLabel = typeof children === 'string' ? children : undefined;

  return (
    <Component
      className={resolvedClassName}
      style={style}
      data-loading-text={shimmerLabel}
      {...props}
    >
      {children}
    </Component>
  );
}
